import React, { useEffect, useState } from 'react';
import { useReducedMotion } from '@hooks/useReducedMotion';

/**
 * AnimatedBackground component
 * Creates a subtle, flowing gradient background animation
 * Uses CSS @keyframes for smooth performance with refined radial gradient design
 */
const AnimatedBackground: React.FC = () => {
  const prefersReducedMotion = useReducedMotion();
  const [isVisible, setIsVisible] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Don't render if user prefers reduced motion
  if (prefersReducedMotion) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 overflow-hidden pointer-events-none"
      style={{
        zIndex: -1,
        width: '120dvw',
        height: '120dvh',
        top: '-10dvh',
        left: '-10dvw',
        background: 'radial-gradient(ellipse 40% 80% at 45% 60%, rgba(99, 225, 202, 0.072) 0%, rgba(34, 197, 94, 0.054) 15%, rgba(16, 185, 129, 0.036) 35%, rgba(5, 150, 105, 0.018) 55%, rgba(5, 150, 105, 0.009) 75%, rgba(5, 150, 105, 0.003) 85%, transparent 100%)',
        filter: 'blur(20px)',
        mixBlendMode: 'screen',
        transformOrigin: '50% 50%',
        willChange: 'transform',
        animation: isVisible ? 'bg-rotate 50s linear infinite' : 'none',
        opacity: 0,
      }}
      aria-hidden="true"
    />
  );
};

export default AnimatedBackground;
